export default __webpack_public_path__ + "static/media/social_media.e71f47e0.png";